<template>
  <v-card-actions class="card-padding crud-listagem-footer">
    <v-row class="align-center pagination-footer-row">
      <v-col cols="12" md="7" lg="6" class="d-flex flex-wrap align-center pagination-toolbar">
        <span class="text-body me-3">{{ $t("Itens_por_pagina") }}:</span>
        <v-select
          :value="pageSize"
          :items="pageSizes"
          @change="$emit('page-size-change', $event)"
          :disabled="loading"
          hide-details
          class="input-style font-size-input text-light-input placeholder-light input-icon pagination-page-size"
          dense
          flat
          filled
          solo
        />
      </v-col>
      <v-col cols="12" md="5" lg="6" class="ml-auto d-flex justify-end pagination-wrapper">
        <v-pagination
          :value="page"
          :length="totalPages"
          @input="$emit('page-change', $event)"
          :disabled="loading"
          prev-icon="fa fa-angle-left"
          next-icon="fa fa-angle-right"
          class="pagination"
          color="#516a78ee"
          circle
        />
      </v-col>
    </v-row>
  </v-card-actions>
</template>

<script>
export default {
  name: "GedHistoricoPaginacao",
  props: {
    page: { type: Number, required: true },
    pageSize: { type: Number, required: true },
    totalPages: { type: Number, required: true },
    loading: { type: Boolean, default: false },
  },
  data: () => ({ pageSizes: [8, 16, 24] }),
};
</script>

<style scoped>
.pagination-toolbar {
  gap: 8px;
}

.pagination-page-size {
  max-width: 96px;
}

.pagination-wrapper {
  min-width: 280px;
}
</style>
